import { NotificationItem } from "../interfaces/common/notifications";

export function getStoredNotifications(): Promise<NotificationItem[]> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('notificationsDB', 1);
  
      request.onerror = (event) => {
        console.error('Failed to open IndexedDB', event);
        reject(event);
      };
  
      request.onsuccess = (event) => {
        try {
            const db = (event.target as IDBOpenDBRequest).result;
            const tx = db.transaction('notifications', 'readonly');
            const store = tx.objectStore('notifications');
            const getAllRequest = store.getAll();
    
            getAllRequest.onsuccess = () => {
            resolve(getAllRequest.result);
            };
            getAllRequest.onerror = (err) => {
            console.error('Failed to get notifications from IndexedDB', err);
            reject(err);
            };
        } catch {
            console.log("failed to process transaction")
        }
        
      };
    });
  }
  

export function clearStoredNotifications(): void {
    const request = indexedDB.open('notificationsDB', 1);
    request.onsuccess = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      const tx = db.transaction('notifications', 'readwrite');
      const store = tx.objectStore('notifications');
      store.clear();
    };
    request.onerror = (event) => {
      console.error('Failed to clear IndexedDB notifications', event);
    };
}